(function () {
  function debounce(fn, wait = 200) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // normalize a string for comparison/search
  function norm(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  // determine sort direction from select option (supports many option value/text conventions)
  function getSortDirection(select) {
    if (!select) return null;
    const v = (select.value || '').toString().toLowerCase();
    const t = (select.selectedOptions && select.selectedOptions[0]) ? select.selectedOptions[0].textContent.toLowerCase() : '';
    if (v.includes('asc') || v.includes('a-z') || v.includes('a_to_z') || t.includes('a - z') || t.includes('a to z') || t.includes('ascending')) return 'asc';
    if (v.includes('desc') || v.includes('z-a') || v.includes('z_to_a') || t.includes('z - a') || t.includes('z to a') || t.includes('descending')) return 'desc';
    // fallback: if value equals 'default' or 'sort' return null
    return null;
  }

  // create or get a "no results" element for the list
  function ensureNoResultsNode(ul) {
    let node = ul.querySelector('.no-results');
    if (!node) {
      node = document.createElement('li');
      node.className = 'no-results grid__item';
      node.style.display = 'none';
      node.style.gridColumn = '1 / -1';
      node.innerHTML = '<div class="tc-note">No results found</div>';
      ul.appendChild(node);
    }
    return node;
  }

  // main initializer for one search-sort block
  function initBlock(searchInput) {
    const searchRow = searchInput.closest('.search-sort-container') || searchInput.parentElement;
    if (!searchRow) return;

    // find the nearest metaobject-list (ul)
    // look up the tree for the section wrapper, then find metaobject-list inside it
    let sectionRoot = searchInput.closest('.multicolumn') || searchInput.closest('div');
    const ul = sectionRoot ? sectionRoot.querySelector('.metaobject-list') : document.querySelector('.metaobject-list');
    if (!ul) return;

    const select = searchRow.querySelector('select') || document.querySelector('select'); // fallback to any select
    const searchButton = searchRow.querySelector('.search__button');

    // collect li children
    const liNodes = Array.from(ul.querySelectorAll('.multicolumn-list__item'));

    // precompute title for each li and store on element.dataset.title for quick access
    liNodes.forEach(li => {
      // try common places for title: h3.inline-richtext OR .multicolumn-card__info h3
      const h3 = li.querySelector('h3.inline-richtext') || li.querySelector('.multicolumn-card__info h3') || li.querySelector('h3');
      const titleText = h3 ? h3.textContent : '';
      li.dataset.title = titleText.trim();
      li.dataset.titleLower = norm(titleText);
    });

    // ensure no results node exists
    const noResultsNode = ensureNoResultsNode(ul);

    // sorting function
    function sortAll(direction) {
      if (!direction) return;
      const compare = (a, b) => {
        // localeCompare for better alphabetical behavior
        const ta = a.dataset.titleLower || '';
        const tb = b.dataset.titleLower || '';
        const cmp = ta.localeCompare(tb, undefined, { numeric: true, sensitivity: 'base' });
        return (direction === 'asc') ? cmp : -cmp;
      };

      // get array of all li elements except the no-results node
      const all = Array.from(ul.querySelectorAll('.multicolumn-list__item')).filter(n => !n.classList.contains('no-results'));
      all.sort(compare);

      // append in order to ul (reorders DOM)
      all.forEach(n => ul.appendChild(n));

      // ensure noResults node is last
      ul.appendChild(noResultsNode);
    }

    // filtering function
    function applyFilterAndSort() {
      const q = norm(searchInput.value);
      // sort direction from select
      const dir = getSortDirection(select);

      // sort all first (so that visible items are in proper order)
      if (dir) {
        sortAll(dir);
      }

      // filter: show/hide based on title match
      let visibleCount = 0;
      liNodes.forEach(li => {
        // if li was removed from DOM (rare) re-query dataset
        const text = li.dataset.titleLower || norm((li.querySelector('h3') || {}).textContent);
        const matches = q === '' || text.indexOf(q) !== -1;
        li.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      // show or hide no-results node
      noResultsNode.style.display = visibleCount === 0 ? '' : 'none';
    }

    // debounce the filter for typing
    const debouncedApply = debounce(applyFilterAndSort, 180);

    // events
    searchInput.addEventListener('input', debouncedApply);
    // optional: pressing ENTER on search input should also run filter immediately
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyFilterAndSort();
      }
    });
    if (searchButton) {
      searchButton.addEventListener('click', function (e) {
        e.preventDefault();
        applyFilterAndSort();
      });
    }

    if (select) {
      select.addEventListener('change', function () {
        const dir = getSortDirection(select);
        if (dir) sortAll(dir);
        // reapply filter (to update visible order)
        applyFilterAndSort();
      });
    }

    // run initial pass (in case select has a default)
    applyFilterAndSort();
  }

  // initialize all search inputs on DOMContentLoaded (and support late-loaded sections if needed)
  function initAll() {
    const inputs = document.querySelectorAll('.search__input');
    inputs.forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();